import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/analytics';
import { productionConfig } from './config/prod-config';
import { stageConfig } from './config/stage-config';

// const firebaseConfig = productionConfig;
const firebaseConfig = productionConfig;

firebase.initializeApp(firebaseConfig);
firebase.analytics();
firebase.firestore();

export default firebase;
